import { React } from "react";
const Header = () => {


  return (
    <div className="dashboard-header">
          <h3>Resume Builder</h3>

    </div>
  );
};

export default Header;
